import { LOAD, ON_SCREEN_R } from '../load.config'

// Pure parts of the atlas: texture sizes per the item F spec, and shelf packing.

const STRUCTURE_KINDS = new Set(['structure', 'brood', 'egg', 'rocket', 'drone'])

// Pixel size of a texture: structures LOAD.structureTexturePx square; everything
// else LOAD.textureScale x its on-screen size in device pixels.
export function textureSize(kind, R, resolution) {
    if (STRUCTURE_KINDS.has(kind)) return { w: LOAD.structureTexturePx, h: LOAD.structureTexturePx }
    const s = ON_SCREEN_R[kind]
    return {
        w: Math.ceil(s.w * R * resolution * LOAD.textureScale),
        h: Math.ceil(s.h * R * resolution * LOAD.textureScale),
    }
}

// Shelf packing into square atlases of side `max`, 2 px padding, tallest first.
export function packShelves(items, max, pad = 2) {
    const sorted = [...items].sort((a, b) => b.h - a.h || b.w - a.w)
    const slots = new Map()
    const atlases = [{ shelves: [] }]
    for (const it of sorted) {
        if (it.w + pad > max || it.h + pad > max) throw new Error(`texture ${it.id} (${it.w}x${it.h}) exceeds the ${max} atlas`)
        let placed = false
        for (let a = 0; a < atlases.length && !placed; a++) {
            const atlas = atlases[a]
            for (const sh of atlas.shelves) {
                if (it.h + pad <= sh.h && sh.x + it.w + pad <= max) {
                    slots.set(it.id, { atlas: a, x: sh.x, y: sh.y })
                    sh.x += it.w + pad
                    placed = true
                    break
                }
            }
            if (!placed) {
                const y = atlas.shelves.reduce((m, sh) => Math.max(m, sh.y + sh.h), 0)
                if (y + it.h + pad <= max) {
                    atlas.shelves.push({ y, h: it.h + pad, x: it.w + pad })
                    slots.set(it.id, { atlas: a, x: 0, y })
                    placed = true
                }
            }
        }
        if (!placed) {
            atlases.push({ shelves: [{ y: 0, h: it.h + pad, x: it.w + pad }] })
            slots.set(it.id, { atlas: atlases.length - 1, x: 0, y: 0 })
        }
    }
    return { atlases, slots }
}
